import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import styles from './addMerchant.module.scss';
import { addMerchant, getMerchantCategories } from '../../api/merchant';
import { getMerchantTags } from '../../api/app';
import CancelAlertPopup from '../../components/CancelAlertPopup/CancelAlertPopup';
import { TagPill } from '../../components';
import AddCategory from '../addCategory/AddCategory';

class AddMerchant extends Component {
  state = {
    validated: false,
    name: '',
    address: '',
    tel: '',
    categoryList: [],
    category: 'Fashion',
    status: 'Active',
    website: '',
    imgUrl: '',
    thumbnail: '',
    description: '',
    termsAndconditions: 'Merchant Terms & Conditions applied',
    statusArray: ['Active', 'Inactive'],
    accountName: '',
    accountNumber: '',
    confirmAccountNumber: '',
    bankName: '',
    email: '',
    branchName: '',
    commission: '',
    apiError: null,
    emailError: null,
    loading: false,
    isSuccess: false,
    key: 'primary',
    glName: '',
    glType: '',
    totalBalance: '',
    glDescription: '',
    confirmError: null,
    primaryFormValidated: false,
    financeFormValidated: false,
    primaryFormValidity: false,
    financeFormValidity: false,
    showCancelPopup: false,
    amountError: null,
    mobileNoError: null,
    commissionError: '',
    disableCancel: true,
    showNewPopup: false,
    isMounted: false,
    tags: [],
    tagsError: null,
    selectedTags: [],
    fieldErrors: {},
  };

  componentDidMount() {
    this.getTags();
    this.getCategories();
  }

  getTags = () => {
    getMerchantTags(this.props.auth.token).then((response) => {
      this.setState({ tags: response });
    });
  };

  getCategories = () => {
    getMerchantCategories(this.props.auth.token).then((response) => {
      this.setState({
        categoryList: response,
        category: response[0],
      });
    });
  };

  handlePrimaryFormValidation = (event) => {
    event.preventDefault();
    const errors = {};

    // Validate required fields
    if (!this.state.name) errors.name = 'Merchant Name is required';
    if (!this.state.address) errors.address = 'Address is required';
    if (!this.state.tel) errors.tel = 'Mobile Number is required';
    if (!this.state.website) errors.website = 'Website is required';
    if (!this.state.imgUrl) errors.imgUrl = 'Image URL is required';
    if (!this.state.thumbnail) errors.thumbnail = 'Thumbnail is required';
    if (!this.state.status) errors.status = 'Status is required';
    if (!this.state.category) errors.category = 'Category is required';

    // Custom validations
    if (this.state.tel && !this.validateMobileNumber()) {
      errors.tel = 'Please enter a valid mobile number';
    }

    // Validate URLs
    if (this.state.website) {
      const websiteError = this.validateUrlField(this.state.website);
      if (websiteError) {
        errors.website = websiteError;
      }
    }

    if (this.state.imgUrl) {
      const imgUrlError = this.validateUrlField(this.state.imgUrl);
      if (imgUrlError) {
        errors.imgUrl = imgUrlError;
      }
    }

    if (this.state.thumbnail) {
      const thumbnailError = this.validateUrlField(this.state.thumbnail);
      if (thumbnailError) {
        errors.thumbnail = thumbnailError;
      }
    }

    // Validate special characters for text fields
    if (this.state.name && !this.isValidCharacters(this.state.name, 'name')) {
      errors.name = 'Merchant Name contains invalid characters';
    }
    if (this.state.address && !this.isValidCharacters(this.state.address, 'address')) {
      errors.address = 'Address contains invalid characters';
    }

    if (this.state.selectedTags.length < 1) {
      errors.tags = 'At least one tag should be selected';
    }

    this.setState({ fieldErrors: errors });

    if (Object.keys(errors).length === 0) {
      this.handleKeyState('finance');
    }
  };

  handleFinanceFormValidation = (event) => {
    event.preventDefault();
    const errors = {};

    // Validate required fields
    if (!this.state.accountName) errors.accountName = 'Account Name is required';
    if (!this.state.accountNumber) errors.accountNumber = 'Account Number is required';
    if (!this.state.confirmAccountNumber) errors.confirmAccountNumber = 'Confirm Account Number is required';
    if (!this.state.bankName) errors.bankName = 'Bank Name is required';
    if (!this.state.branchName) errors.branchName = 'Branch Name is required';
    if (!this.state.email) errors.email = 'Email Address is required';

    // Custom validations
    if (this.state.accountNumber && this.state.confirmAccountNumber && !this.confirmAccountNumbers()) {
      errors.confirmAccountNumber = 'Entered account numbers do not match';
    }

    if (this.state.email && !this.validatedEmail()) {
      errors.email = 'Please enter a valid email address';
    }

    if (this.state.commission && this.state.commission[this.state.commission.length - 1] === '.') {
      errors.commission = 'Enter a valid commission';
    }

    // Validate special characters for text fields
    if (this.state.accountName && !this.isValidCharacters(this.state.accountName, 'accountName')) {
      errors.accountName = 'Account Name contains invalid characters';
    }
    if (this.state.bankName && !this.isValidCharacters(this.state.bankName, 'bankName')) {
      errors.bankName = 'Bank Name contains invalid characters';
    }
    if (this.state.branchName && !this.isValidCharacters(this.state.branchName, 'branchName')) {
      errors.branchName = 'Branch Name contains invalid characters';
    }

    this.setState({ fieldErrors: errors });

    if (Object.keys(errors).length === 0) {
      this.handleKeyState('gl');
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const errors = {};

    // Validate GL Account required fields
    if (!this.state.glName) errors.glName = 'Name is required';
    if (!this.state.glType) errors.glType = 'Type is required';
    if (!this.state.totalBalance) errors.totalBalance = 'Total Balance is required';
    if (!this.state.glDescription) errors.glDescription = 'Description is required';

    // Custom validations
    if (this.state.totalBalance && isNaN(this.state.totalBalance)) {
      errors.totalBalance = 'Please enter a valid total balance';
    }

    // Validate special characters for text fields
    if (this.state.glName && !this.isValidCharacters(this.state.glName, 'glName')) {
      errors.glName = 'Name contains invalid characters';
    }
    if (this.state.glType && !this.isValidCharacters(this.state.glType, 'glType')) {
      errors.glType = 'Type contains invalid characters';
    }

    this.setState({ fieldErrors: errors });

    if (Object.keys(errors).length > 0) {
      return;
    }

    this.setState({ loading: true });

    const description = `<p class="ql-align-justify"><span style="font-size: 11pt; background-color: rgb(255, 255, 255); font-family: Poppins, sans-serif; color: rgb(33, 37, 41);">${this.state.description}</span></p><p><br></p>`;
    const termsAndconditions = `<p><br></p><p class="ql-align-justify"><span style="font-size: 11pt; font-family: Poppins, sans-serif; color: rgb(33, 37, 41);">${this.state.termsAndconditions}</span></p><p><br></p>`;

    const request = {
      name: this.state.name,
      address: this.state.address,
      tel: this.state.tel,
      category: this.state.category,
      status: this.state.status,
      website: this.state.website,
      imgUrl: this.state.imgUrl,
      thumbnail: this.state.thumbnail,
      description: description,
      termsAndConditions: termsAndconditions,
      accountName: this.state.accountName,
      accountNumber: this.state.accountNumber,
      bankName: this.state.bankName,
      email: this.state.email,
      bankBranchCode: this.state.branchName,
      commission: this.state.commission / 100,
      glName: this.state.glName,
      glType: this.state.glType,
      totalBalance: this.state.totalBalance,
      glDescription: this.state.glDescription,
      tagIds: this.state.selectedTags,
    };

    addMerchant(request, this.props.auth.token)
      .then((response) => {
        this.setState({
          isSuccess: true,
          loading: false,
          apiError: null,
        });
        // Clear all states after 2 seconds
        setTimeout(() => {
          this.handleClear();
        }, 500);
      })
      .catch((err) => {
        this.setState({
          apiError: err,
          loading: false,
          isSuccess: false,
        });
      });
  };

  confirmAccountNumbers = () => {
    return this.state.confirmAccountNumber === this.state.accountNumber;
  };

  handleQuillChange = (content, name) => {
    const newFieldErrors = { ...this.state.fieldErrors };
    delete newFieldErrors[name];

    this.setState({
      [name]: content,
      fieldErrors: newFieldErrors,
    });
  };

  handleInputChange = (event) => {
    let { name, value } = event.target;
    let item = this.state[name];
    if (item.length === 0) {
      value = value.trim();
    }

    // Validate special characters for text inputs
    if (!this.isValidCharacters(value, name)) {
      return; // Reject invalid characters
    }

    const newFieldErrors = { ...this.state.fieldErrors };
    delete newFieldErrors[name];

    // Validate URL fields on input change
    if ((name === 'website' || name === 'imgUrl' || name === 'thumbnail') && value) {
      const urlError = this.validateUrlField(value);
      if (urlError) {
        newFieldErrors[name] = urlError;
      }
    }

    this.setState({
      [name]: value,
      disableCancel: false,
      fieldErrors: newFieldErrors,
    });

    if (event.target.name === 'email') {
      this.setState({
        emailError: null,
      });
    }
    if (event.target.name === 'confirmAccountNumber') {
      this.setState({
        confirmError: null,
      });
    }
  };

  handleDropDownChange = (event, name) => {
    let { value } = event.target;

    const newFieldErrors = { ...this.state.fieldErrors };
    delete newFieldErrors[name];

    this.setState({
      [name]: value,
      fieldErrors: newFieldErrors,
    });
  };

  handleNumberChange = (event) => {
    let { name, value } = event.target;
    let item = this.state[name];
    if (item.length === 0) {
      value = value.trim();
    }

    const newFieldErrors = { ...this.state.fieldErrors };
    delete newFieldErrors[name];

    this.setState({
      [name]: value.replace(/[^0-9\s]/g, ''),
      fieldErrors: newFieldErrors,
    });
  };

  handleAmountOnChange = (event) => {
    let { name, value } = event.target;
    let item = this.state[name];
    if (item.length === 0) {
      value = value.trim();
    }
    if (value.length === 1 && value === '.') {
      value = '0.';
    }

    const newFieldErrors = { ...this.state.fieldErrors };
    delete newFieldErrors[name];

    if (value.split('').filter((letter) => letter === '.').length <= 1) {
      this.setState({
        [name]: value.replace(/[^0-9.\s]/g, ''),
        fieldErrors: newFieldErrors,
      });
    }
  };

  validateMobileNumber = () => {
    const tel = this.state.tel;
    if (tel.length < 10) {
      return false;
    } else {
      const reg = /^[0]\d{9}$/;
      return reg.test(this.state.tel);
    }
  };

  validatedEmail = () => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const result = pattern.test(this.state.email);

    if (!result) {
      this.setState({
        emailError: 'Enter a valid email address',
      });
    }
    return result;
  };

  validateUrlField = (url) => {
    if (!url || url.trim() === '') {
      return null; // Empty URLs are handled by required field validation
    }
    if (!url.startsWith('https://')) {
      return 'URL must start with https://';
    }
    return null; // Valid URL
  };

  handleNext = (event) => {
    const key = this.state.key;
    if (key === 'primary') {
      this.handlePrimaryFormValidation(event);
    } else if (key === 'finance') {
      this.handleFinanceFormValidation(event);
    } else {
      this.handleKeyState('primary');
    }
  };

  handleKeyState = (key) => {
    this.setState({
      key,
    });
  };

  handleCancel = () => {
    this.setState({
      showCancelPopup: !this.state.showCancelPopup,
    });
  };

  handleClear = () => {
    this.setState({
      name: '',
      address: '',
      tel: '',
      category: 'Fashion',
      status: 'Active',
      website: '',
      imgUrl: '',
      thumbnail: '',
      description: '',
      termsAndconditions: 'Merchant Terms & Conditions applied',
      accountName: '',
      accountNumber: '',
      bankName: '',
      email: '',
      branchName: '',
      commission: '',
      glName: '',
      glType: '',
      totalBalance: '',
      glDescription: '',
      confirmAccountNumber: '',
      financeFormValidated: false,
      primaryFormValidated: false,
      validated: false,
      confirmError: null,
      mobileNoError: null,
      amountError: null,
      emailError: null,
      fieldErrors: {},
      apiError: null,
      isSuccess: false,
      key: 'primary',
      disableCancel: true,
      selectedTags: [],
      showCancelPopup: false,
    });
  };

  handleNewOnClick = () => {
    this.setState({
      showNewPopup: !this.state.showNewPopup,
    });
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  renderApiResponse = (message) => {
    return (
      <Card className={styles.card_footer}>
        <Card.Body>
          <span
            className={
              this.state.isSuccess ? styles.success_msg : styles.error_msg
            }
          >
            {message}
          </span>
        </Card.Body>
      </Card>
    );
  };

  renderQuillText = (name, label, value, onChange, max, isRequired = true) => {
    return (
      <Form.Group as={Row}>
        <Col>
          <Form.Label>
            {label}
            {isRequired && <span style={{ color: 'red' }}>*</span>}
          </Form.Label>
          <div className={this.state.fieldErrors && this.state.fieldErrors[name] ? 'has-error' : ''}>
            <ReactQuill
              theme='snow'
              name={name}
              value={value}
              onChange={(content) => onChange(content, name)}
              maxLength={max}
            />
          </div>
          {this.state.fieldErrors && this.state.fieldErrors[name] && (
            <small className={styles.error_msg} style={{ display: 'block' }}>
              {this.state.fieldErrors[name]}
            </small>
          )}
        </Col>
      </Form.Group>
    );
  };

  renderTextArea = (name, label, value, onChange, max, isRequired = true) => {
    const currentLength = value.length;
    const isNearLimit = currentLength >= Math.ceil(max * 0.8) && currentLength < max;
    const isAtLimit = currentLength === max;
    const hasError = !!this.state.fieldErrors && !!this.state.fieldErrors[name];

    return (
      <Form.Group as={Row}>
        <Col>
          <Form.Label className={styles.form__label}>
            {label}
            {isRequired && <span className={styles.required__asterisk}>*</span>}
          </Form.Label>
          <div className={styles['input__wrapper--textarea']}>
            <Form.Control
              aria-label={label}
              aria-describedby='basic-addon2'
              name={name}
              value={value}
              onChange={onChange}
              isInvalid={hasError || isAtLimit}
              as='textarea'
              maxLength={max}
              placeholder={`Enter ${label.toLowerCase()}`}
              className={`
                ${styles.input__with_counter} 
                ${isNearLimit ? styles['input__with_counter--warning'] : ''}
                ${isAtLimit ? styles['input__with_counter--error'] : ''}
                ${hasError ? styles['input__with_counter--invalid'] : ''}
                `}
            />
            <small className={`${styles.char__counter} ${isAtLimit ? styles['char__counter--error'] : isNearLimit ? styles['char__counter--warning'] : styles['char__counter--normal']}`}>
              {currentLength}/{max}
            </small>
          </div>
          {hasError && (
            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
              {this.state.fieldErrors[name]}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    );
  };

  renderDropDown = (name, label, data, value, onChange) => {
    return (
      <Form.Group as={Row}>
        <Col>
          <Form.Label>{label} <span className={styles.required__asterisk}>*</span></Form.Label>
          <select
            id='x-select'
            className={`form-control form-control-sm custom-select ${this.state.fieldErrors && this.state.fieldErrors[name] ? styles['select__with_error'] : ''}`}
            onClick={(event) => onChange(event, name)}
            name={name}
          >
            {data &&
              data.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
          </select>
          {this.state.fieldErrors && this.state.fieldErrors[name] && (
            <small className={styles.error_msg}>
              {this.state.fieldErrors[name]}
            </small>
          )}
          {name === 'category' && (
            <span
              className={styles.new_category_link}
              onClick={this.handleNewOnClick}
            >
              Add Category
            </span>
          )}
        </Col>
      </Form.Group>
    );
  };

  renderInputField = (name, label, value, onChange, max, isRequired = true) => {
    const currentLength = value.length;
    const isNearLimit = currentLength >= Math.ceil(max * 0.8) && currentLength < max;
    const isAtLimit = currentLength === max;
    const hasError = !!this.state.fieldErrors && !!this.state.fieldErrors[name];

    return (
      <Form.Group as={Row}>
        <Col>
          <Form.Label className={styles.form__label}>
            {label}
            {isRequired && <span className={styles.required__asterisk}>*</span>}
          </Form.Label>
          <div className={styles.input__wrapper}>
            <Form.Control
              name={name}
              value={value}
              onChange={onChange}
              maxLength={max}
              isInvalid={hasError || isAtLimit}
              placeholder={
                name === 'imgUrl' || name === 'thumbnail'
                  ? `https://example.com/${name}.png`
                  : name === 'commission'
                    ? 'Enter commission as a percentage (e.g. 5%)'
                    : name === 'tel'
                      ? '+947XXXXXXXX/07XXXXXXXX'
                      : `Enter ${label.toLowerCase()}`
              }
              className={`
                ${styles.input__with_counter}
                ${isNearLimit ? styles['input__with_counter--warning'] : ''}
                ${isAtLimit ? styles['input__with_counter--error'] : ''}
                ${hasError ? styles['input__with_counter--invalid'] : ''}
                `}
            />
            <small className={`${styles.char__counter} ${isAtLimit ? styles['char__counter--error'] : isNearLimit ? styles['char__counter--warning'] : styles['char__counter--normal']}`}>
              {currentLength}/{max}
            </small>
          </div>
          {hasError && (
            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
              {this.state.fieldErrors[name]}
            </Form.Control.Feedback>
          )}
          {name === 'email' && this.state.emailError
            ? this.renderAdditionalErrorMessage(this.state.emailError)
            : null}
          {name === 'totalBalance' && this.state.amountError
            ? this.renderAdditionalErrorMessage(this.state.amountError)
            : null}
          {name === 'tel' && this.state.mobileNoError
            ? this.renderAdditionalErrorMessage(this.state.mobileNoError)
            : null}
          {name === 'confirmAccountNumber' && this.state.confirmError
            ? this.renderAdditionalErrorMessage(this.state.confirmError)
            : null}
          {name === 'commission' && this.state.commissionError
            ? this.renderAdditionalErrorMessage(this.state.commissionError)
            : null}
        </Col>
      </Form.Group>
    );
  };

  renderAdditionalErrorMessage = (err) => {
    return <small className={styles.error_msg}>{err}</small>;
  };

  // Character limit and special character validation
  isValidCharacters = (value, fieldName) => {
    // Allow alphanumeric, spaces, and common special characters for most fields
    const specialCharPattern = /^[a-zA-Z0-9\s.,&@\-():\\/]+$/;
    const numericPattern = /^[0-9\s./-]+$/;

    // Fields that require at least one letter (for text fields)
    const restrictedFields = ['name', 'accountName', 'bankName', 'branchName', 'glName', 'glType'];
    const numericFields = ['accountNumber', 'confirmAccountNumber', 'totalBalance'];

    // Check numeric fields first
    if (numericFields.includes(fieldName)) {
      return numericPattern.test(value) || value === '';
    }

    // For restricted text fields, require at least one letter and valid characters
    if (restrictedFields.includes(fieldName)) {
      // Must contain at least one letter (uppercase or lowercase)
      const hasLetter = /[a-zA-Z]/.test(value);
      const validCharacters = specialCharPattern.test(value);
      return (hasLetter && validCharacters) || value === '';
    }

    // Default: allow general characters
    return true;
  };

  getCharacterLimitMessage = (currentLength, maxLength, fieldName) => {
    return `${currentLength}/${maxLength}`;
  };

  renderPrimaryForm = () => {
    return (
      <Form onSubmit={this.handlePrimaryFormValidation}>
        <Row>
          <Col>
            {this.renderInputField(
              'name',
              'Merchant Name',
              this.state.name,
              this.handleInputChange,
              50
            )}
          </Col>
          <Col>
            {this.renderInputField(
              'address',
              'Address',
              this.state.address,
              this.handleInputChange,
              320
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'tel',
              'Mobile Number',
              this.state.tel,
              this.handleNumberChange,
              20
            )}
          </Col>
          <Col>
            {this.renderInputField(
              'website',
              'Website (URL)',
              this.state.website,
              this.handleInputChange,
              320
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'imgUrl',
              'Image URL',
              this.state.imgUrl,
              this.handleInputChange,
              320
            )}
          </Col>
          <Col>
            {this.renderInputField(
              'thumbnail',
              'Thumbnail',
              this.state.thumbnail,
              this.handleInputChange,
              320
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderDropDown(
              'status',
              'Status',
              this.state.statusArray,
              this.state.status,
              this.handleDropDownChange
            )}
          </Col>
          <Col>
            {this.renderDropDown(
              'category',
              'Category',
              this.state.categoryList,
              this.state.category,
              this.handleDropDownChange
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group as={Row}>
              <Col>
                <Form.Label>Choose Merchant Tag(s) <span className={styles.required__asterisk}>*</span></Form.Label>
                <div className={styles.category__list}>
                  {this.state.tags.map((tag, index) => (
                    <TagPill
                      key={index}
                      id={tag.id}
                      title={tag.name}
                      selected={this.state.selectedTags.includes(tag.id)}
                      onSelect={(key) => {
                        const updatedTagList = this.state.selectedTags.includes(
                          key
                        )
                          ? this.state.selectedTags.filter((id) => id !== key)
                          : [...this.state.selectedTags, key];
                        this.setState({
                          selectedTags: updatedTagList,
                        });
                      }}
                    />
                  ))}
                </div>
                {this.state.fieldErrors && this.state.fieldErrors.tags
                  ? this.renderAdditionalErrorMessage(this.state.fieldErrors.tags)
                  : null}
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderQuillText(
              'description',
              'Description',
              this.state.description,
              this.handleQuillChange,
              350,
              false
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderQuillText(
              'termsAndconditions',
              'Terms and Conditions',
              this.state.termsAndconditions,
              this.handleQuillChange,
              350,
              false
            )}
          </Col>
        </Row>

        {this.renderBtnFooter()}
      </Form>
    );
  };

  renderFinanceForm = () => {
    return (
      <Form onSubmit={this.handleFinanceFormValidation}>
        <Row>
          <Col>
            {this.renderInputField(
              'accountName',
              'Account Name',
              this.state.accountName,
              this.handleInputChange,
              20
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'accountNumber',
              'Account Number',
              this.state.accountNumber,
              this.handleNumberChange,
              20
            )}
          </Col>
          <Col>
            {this.renderInputField(
              'confirmAccountNumber',
              'Confirm Account Number',
              this.state.confirmAccountNumber,
              this.handleNumberChange,
              20
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'bankName',
              'Bank Name',
              this.state.bankName,
              this.handleInputChange,
              20
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'branchName',
              'Branch Name',
              this.state.branchName,
              this.handleInputChange,
              20
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'email',
              'Email Address',
              this.state.email,
              this.handleInputChange,
              320
            )}
          </Col>
          <Col>
            {this.renderInputField(
              'commission',
              'Commission',
              this.state.commission,
              this.handleAmountOnChange,
              10
            )}
          </Col>
        </Row>

        {this.renderBtnFooter()}
      </Form>
    );
  };

  renderGLForm = () => {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            {this.renderInputField(
              'glName',
              'Name',
              this.state.glName,
              this.handleInputChange,
              50
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'glType',
              'Type',
              this.state.glType,
              this.handleInputChange,
              20
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderInputField(
              'totalBalance',
              'Total Balance',
              this.state.totalBalance,
              this.handleAmountOnChange,
              10
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            {this.renderTextArea(
              'glDescription',
              'Description',
              this.state.glDescription,
              this.handleInputChange,
              350
            )}
          </Col>
        </Row>

        <div className={styles.form_footer}>
          <Button
            variant='secondary'
            onClick={this.handleCancel}
            className={styles.footer_btn}
            disabled={this.state.disableCancel}
          >
            Cancel{' '}
          </Button>
          <Button variant='dark' type='submit' className={styles.next_btn}>
            {this.state.loading ? 'Loading' : 'Submit'}
          </Button>
        </div>

        {this.state.isSuccess
          ? this.renderApiResponse('New Merchant Added Successfully')
          : this.state.apiError
            ? this.renderApiResponse('Failed to Add New Merchant')
            : null}
      </Form>
    );
  };

  renderTabs = () => {
    return (
      <Tabs
        id='controlled-tab-example'
        activeKey={this.state.key}
        onSelect={(k) => {
          this.setState({ key: k });
        }}
      >
        <Tab eventKey='primary' title='Primary Details' />
        <Tab eventKey='finance' title='Finance Details' />
        <Tab eventKey='gl' title='GL Account Details' />
      </Tabs>
    );
  };

  renderBtnFooter = () => {
    return (
      <div className={styles.form_footer}>
        <Button
          variant='secondary'
          onClick={this.handleCancel}
          className={styles.footer_btn}
          disabled={this.state.disableCancel}
        >
          {' '}
          Cancel
        </Button>
        <Button variant='dark' type='submit' className={styles.footer_btn}>
          {' '}
          Next{' '}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <div className={styles.div_root}>
        <Card>
          <Card.Header as='h5'>
            <Col className={styles.tab}>{this.renderTabs()}</Col>
          </Card.Header>
          <Col className={styles.form_root}>
            {this.state.key === 'primary'
              ? this.renderPrimaryForm()
              : this.state.key === 'finance'
                ? this.renderFinanceForm()
                : this.renderGLForm()}
          </Col>
        </Card>
        <CancelAlertPopup
          show={this.state.showCancelPopup}
          alertMessage='Are you sure you want to cancel ?'
          handleYesBtnClick={this.handleClear}
          handleNoBtnClick={this.handleCancel}
        />

        <AddCategory
          showModal={this.state.showNewPopup}
          handleModalShow={this.handleNewOnClick}
          handleCloseModalShow={this.handleNewOnClick}
          token={this.props.auth.token}
          getCategories={this.getCategories}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(AddMerchant);


